import { queryOptions } from "@tanstack/react-query";
import type {
  OAuthProviderItem,
  OAuthProviderResponse,
} from "@/app/oauth/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { oauthProvidersKeys } from "./query-keys";

const DEFAULT_OAUTH_PROVIDERS_LIMIT = 1000;

const fetchOAuthProviders = async ({
  client,
  params,
}: {
  client: ApiClient;
  params?: { limit?: number; offset?: number };
}): Promise<OAuthProviderItem[]> => {
  const resolved = {
    limit: params?.limit ?? DEFAULT_OAUTH_PROVIDERS_LIMIT,
    offset: params?.offset ?? 0,
  };
  const { data } = await client.get<OAuthProviderResponse>("/auth_providers", {
    params: resolved,
  });
  return data?.items ?? [];
};

export const oauthProvidersQueryOptions = ({
  binding = "project",
  params,
  scope,
}: {
  binding?: ScopedBinding;
  params?: { limit?: number; offset?: number };
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<OAuthProviderItem[]>({
    queryKey: oauthProvidersKeys.list({ binding, scope }),
    queryFn: () => fetchOAuthProviders({ client, params }),
  });
};
